import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as tomorrowItemsService from '_services/tomorrow-items'

export const GET_TOMORROW_ITEMS = defineAction('GET_TOMORROW_ITEMS')
export const SET_TOMORROW_ITEMS_ORDER = defineAction('SET_TOMORROW_ITEMS_ORDER')
export const DELETE_TOMORROW_ITEM = defineAction('DELETE_TOMORROW_ITEM')
export const CREATE_TOMORROW_ITEM = defineAction('CREATE_TOMORROW_ITEM')
export const EDIT_TOMORROW_ITEM = defineAction('EDIT_TOMORROW_ITEM')
export const CHECK_TOMORROW_ITEM = defineAction('CHECK_TOMORROW_ITEM')
export const UNDO_TOMORROW_ITEM = defineAction('UNDO_TOMORROW_ITEM')

export const getTomorrowItems = id => (dispatch, getState) =>
  dispatch({
    type: GET_TOMORROW_ITEMS.ACTION,
    payload: tomorrowItemsService.getTomorrowItems(getState().user.get('token'))(id),
  })

export const setTomorrowItemsOrder = payload => (dispatch, getState) =>
  dispatch({
    type: SET_TOMORROW_ITEMS_ORDER.ACTION,
    payload: tomorrowItemsService
      .setTomorrowItemsOrder(getState().user.get('token'))(payload)
      .then(() =>
        tomorrowItemsService.getTomorrowItems(getState().user.get('token'))(payload.sectionId)
      ),
  })

export const deleteTomorrowItem = payload => (dispatch, getState) =>
  dispatch({
    type: DELETE_TOMORROW_ITEM.ACTION,
    payload: tomorrowItemsService
      .deleteTomorrowItem(getState().user.get('token'))(payload)
      .then(() =>
        tomorrowItemsService.getTomorrowItems(getState().user.get('token'))(payload.sectionId)
      ),
  })

export const createTomorrowItem = payload => (dispatch, getState) =>
  dispatch({
    type: CREATE_TOMORROW_ITEM.ACTION,
    payload: tomorrowItemsService
      .createTomorrowItem(getState().user.get('token'))(payload)
      .then(() =>
        tomorrowItemsService.getTomorrowItems(getState().user.get('token'))(payload.sectionId)
      ),
  })

export const editTomorrowItem = payload => (dispatch, getState) =>
  dispatch({
    type: EDIT_TOMORROW_ITEM.ACTION,
    payload: tomorrowItemsService
      .updateTomorrowItem(getState().user.get('token'))(payload)
      .then(() =>
        tomorrowItemsService.getTomorrowItems(getState().user.get('token'))(payload.sectionId)
      ),
  })

export const checkTomorrowItem = payload => (dispatch, getState) =>
  dispatch({
    type: CHECK_TOMORROW_ITEM.ACTION,
    payload: tomorrowItemsService
      .checkTomorrowItem(getState().user.get('token'))(payload)
      .then(() =>
        tomorrowItemsService.getTomorrowItems(getState().user.get('token'))(payload.sectionId)
      ),
  })

export const undoTomorrowItem = () => (dispatch, getState) =>
  dispatch({
    type: UNDO_TOMORROW_ITEM.ACTION,
    payload: tomorrowItemsService
      .undoTomorrowItem(getState().user.get('token'))
      .then(() => tomorrowItemsService.getTomorrowItems(getState().user.get('token'))()),
  })



// WEBPACK FOOTER //
// ./src/modules/tomorrow-items/actions.js